import { lazy } from 'react';
import { isChunkLoadError, tryReloadForStaleChunk } from './chunkLoadError';

/**
 * React.lazy wrapper that recovers from post-deploy stale chunk hashes.
 * @param {() => Promise<{ default: React.ComponentType }>} factory
 */
export function lazyWithRetry(factory) {
  return lazy(() =>
    factory().catch((error) => {
      if (isChunkLoadError(error) && tryReloadForStaleChunk()) {
        return new Promise(() => {});
      }
      throw error;
    }),
  );
}
